import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { getPreset } from "@/lib/showcasePresets";

const ShowcasePrivacy = () => {
  const { slug } = useParams();
  const [site, setSite] = useState(null);
  useEffect(() => { api.get(`/showcase/${slug}`).then((r) => setSite(r.data)).catch(() => setSite({ name: "Sito", preset: "elegant_dark" })); }, [slug]);
  if (!site) return null;
  const t = getPreset(site.preset);
  const c = site.content || {};
  const custom = c.privacy?.text;
  const contact = c.contact || {};
  const contactLine = [contact.email, contact.address].filter(Boolean).join(" · ");
  return (
    <div style={{ backgroundColor: t.bg, color: t.text, fontFamily: t.body, minHeight: "100vh" }} data-testid="showcase-privacy">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-4xl mb-6" style={{ fontFamily: t.heading, color: t.accent }}>Privacy Policy</h1>
        {custom ? (
          <div className="text-sm leading-relaxed whitespace-pre-line" style={{ color: t.muted }} data-testid="privacy-custom">{custom}</div>
        ) : (
          <div className="space-y-4 text-sm leading-relaxed" style={{ color: t.muted }} data-testid="privacy-auto">
            <p>Il presente sito ({site.name}) raccoglie i dati personali forniti volontariamente dagli utenti tramite il modulo di prenotazione (nome, recapito telefonico o email, data, ora, numero di persone ed eventuali note).</p>
            <p><strong style={{ color: t.text }}>Finalità:</strong> i dati sono utilizzati esclusivamente per gestire la richiesta di prenotazione e ricontattare l'utente. Non vengono ceduti a terzi per finalità commerciali.</p>
            <p><strong style={{ color: t.text }}>Cookie:</strong> il sito utilizza cookie tecnici necessari al funzionamento e alla memorizzazione del consenso. Non vengono utilizzati cookie di profilazione senza consenso.</p>
            <p><strong style={{ color: t.text }}>Diritti:</strong> l'utente può richiedere in qualsiasi momento accesso, rettifica o cancellazione dei propri dati contattando il ristorante{contactLine ? ` (${contactLine})` : " ai recapiti indicati sul sito"}.</p>
            <p><strong style={{ color: t.text }}>Titolare del trattamento:</strong> {site.name}.</p>
          </div>
        )}
        <Link to={`/s/${slug}`} className="inline-block mt-8 rounded-full px-6 py-3 text-sm font-semibold" style={{ backgroundColor: t.accent, color: t.dark ? "#0B0B0C" : "#fff" }}>← Torna al sito</Link>
      </div>
    </div>
  );
};

export default ShowcasePrivacy;
